import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcessingStore = defineStore("processing", () => {
  const isProcessing = ref(false);

  return {
    isProcessing,
  };
});
